<template>
<div class="empty">
    <img src="/img/empty.png"></img>
    <span>当前城市暂无领养信息~</span>
</div>
</template>
<script>
export default {
    name: 'Empty',
    props: {
        extClass: {
            type: String,
            default: '',
        },
        tips: {
            type: String,
            default: '全部加载完毕',
        },
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
        };
    },
};
</script>
<style scoped lang="scss">
.empty {
    height: 150px;
    text-align: center;
}
.empty span {
    display: inline-block;
    width: 100%;
    font-size: 13px;
    color: #9F9F9F;
    padding: 0 0 50px;
}
.empty img {
    display: block;
    width: 110px;
    height: 75px;
    margin: 50px auto 25px;
}
</style>
